import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss'],
  standalone: false,
})
export class PageContainerComponent {
  @Input() fullWidth = false;
}
